// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3_ycg","ranges":"BmiRanges_ranges__3oDDm"};